export default "da39aefb5480e7aa.png"